var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1208 33.4984C27.3245 30.2432 32.5186 30.2437 35.7222 33.4991C38.9256 36.7545 38.9256 42.0319 35.7222 45.2873C32.5186 48.5427 27.3245 48.5432 24.1208 45.288C20.9171 42.0325 20.9171 36.7538 24.1208 33.4984Z",
    stroke: "#005FC8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5312 24.0087H0.3125V54.7803H59.5312V24.0087Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83513 52.2197C8.83513 48.6412 5.98053 45.7405 2.45898 45.7405",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 32.9195C5.98053 32.9195 8.83513 30.0188 8.83513 26.4403",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0068 26.4498C51.0068 30.0283 53.8614 32.929 57.383 32.929",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.383 45.7405C53.8614 45.7405 51.0068 48.6412 51.0068 52.2197",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83594 26.449L51.0074 26.4498",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 45.7405V32.9196",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0074 52.2197H8.83594",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3838 32.9753V45.7404",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2482 45.8223C39.7425 42.2716 39.7425 36.5148 36.2482 32.9641C32.754 29.4134 27.0887 29.4134 23.5945 32.9641C20.1002 36.5148 20.1002 42.2716 23.5945 45.8223C27.0887 49.373 32.754 49.373 36.2482 45.8223Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74512 23.8756L8.29793 10.2438L48.0738 23.9597",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51367 19.3832C10.8484 20.5333 14.4688 18.7183 15.6007 15.3297",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5977 15.3391L40.6508 23.9777",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00488 23.9022L7.51375 19.3832",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2207 12.9735L26.6847 1.28125L51.2603 23.9915",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.373 9.34186C24.9783 11.7495 29.0112 11.5554 31.3806 8.90723",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.374 8.91492L47.3351 23.6642",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5312 13.6349L22.3732 9.3418",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2534 35.1752L30.251 33.9554",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2739 44.9623L30.2715 43.7417",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.017 37.6868L32.0137 36.0762C32.0035 35.5402 31.6747 35.1752 31.2005 35.1752H29.3231C28.5876 35.1752 28.3138 35.4758 28.329 36.3081L28.3433 37.606C28.3501 37.9479 28.487 38.2297 28.722 38.3825L31.6172 40.2706C31.8522 40.4243 31.99 40.7052 31.9959 41.0471L32.0153 42.5133C32.0314 43.3457 31.8818 43.7399 31.1464 43.7399H29.1464C28.6722 43.7399 28.3433 43.3757 28.3332 42.8389L28.3281 41.3683",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.eab99c93.svg";
export { ForwardRef as ReactComponent };